import React, { useState } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import type { Route } from '../../../types';
import type { CorrectionContext } from '../hooks/useCorrectionContext';
import { RouteCompletionModal } from '../../executionOperations';
import { CarrierReplacementWizard } from '../wizards/CarrierReplacementWizard';
import type { RouteViewModel } from '../../../types/routeViewModel';

const { Text, Paragraph } = Typography;

type Props = {
  route: Route;
  routeId: number;
  view: RouteViewModel;
  ctx: CorrectionContext;
  onSuccess: () => void;
};

export function RouteManagementPanel({ route, routeId, view, ctx, onSuccess }: Props) {
  const [completionOpen, setCompletionOpen] = useState(false);
  const [carrierWizardOpen, setCarrierWizardOpen] = useState(false);

  const canEarlyCompletion = ctx.isOperationAllowed('EARLY_COMPLETION');
  const canCarrierReplacement = ctx.isOperationAllowed('CARRIER_REPLACEMENT');

  return (
    <div className="mutation-workspace__section">
      <div className="mutation-workspace__section-title">Управление маршрутом</div>

      <Paragraph type="secondary">
        Досрочное завершение и замена перевозчика выполняются отдельными операциями с фиксацией в журнале.
      </Paragraph>

      <Space direction="vertical" style={{ width: '100%' }}>
        {canEarlyCompletion && (
          <Button type="default" onClick={() => setCompletionOpen(true)}>
            Завершить маршрут
          </Button>
        )}

        {canCarrierReplacement ? (
          <Button type="primary" onClick={() => setCarrierWizardOpen(true)}>
            Замена перевозчика
          </Button>
        ) : (
          <Alert
            type="warning"
            showIcon
            message="Замена перевозчика недоступна"
            description={
              ctx.correction.executionLock.executionComplete
                ? 'Операция временно недоступна.'
                : 'Замена перевозчика доступна после полного завершения исполнения маршрута.'
            }
          />
        )}

        {!canEarlyCompletion && !canCarrierReplacement && (
          <Text type="secondary">Операции управления недоступны для текущего статуса.</Text>
        )}
      </Space>

      <RouteCompletionModal
        open={completionOpen}
        route={route}
        onClose={() => setCompletionOpen(false)}
        onCompleted={() => {
          setCompletionOpen(false);
          onSuccess();
        }}
      />

      <CarrierReplacementWizard
        route={route}
        routeId={routeId}
        view={view}
        ctx={ctx}
        open={carrierWizardOpen}
        onClose={() => setCarrierWizardOpen(false)}
        onSuccess={onSuccess}
      />
    </div>
  );
}
